export default __webpack_public_path__ + "static/media/step_2.7df8ace6.svg";